const config =  {
    ip: "127.0.0.1",
    port:"1366",
    portApi:"5000",
    // Produccion: base de la API detras del proxy (REACT_APP_API_URL=/api). Vacio = http://ip:portApi
    apiUrl: process.env.REACT_APP_API_URL || '',
    session:null,
    ContextSession:'ContextSession',
    build:'debug'
}

export default config;